import React, { FunctionComponent, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { setImagePath, getClientIdParamValue } from '../../utils/helpers';
import { capturePageLoadAnalytics } from '../../utils/analytics/analyticsDispatchers';
import { API_SYSTEM_ERROR_EVENT } from '../../utils/analytics/analyticsEvents';
import { getRetrieveAccountErrorContent } from '../../store/contentSlice';

const LowesAccountError: FunctionComponent = () => {
  const clientId = getClientIdParamValue();
  const {
    heading,
    subHeading,
    contentTitle,
    contentLine1,
    contentLine2,
    contentLine3,
    contentLine4,
    contentLine5,
  }: any = useSelector((state: any) =>
    getRetrieveAccountErrorContent(state, clientId),
  );
  useEffect(() => {
    capturePageLoadAnalytics(API_SYSTEM_ERROR_EVENT);
  }, []);

  return (
    <div className="error-pg-container">
      <div className="error-pg-box-wrapper">
        <div className="error-pg-img-wrapper">
          <img
            className="error-pg-img"
            src={setImagePath('trouble-connecting')}
            alt="system down error"
          />
        </div>
        <div className="error-message-wrapper account-error-content">
          <p className="error-pg-heading">{heading}</p>
          <p className="error-pg-message">{subHeading}</p>
          <div className="error-message-wrapper account-error-message-content">
            <p className="error-pg-message-content">{contentTitle}</p>
            <div className="error-pg-message-content error-desc-bullet-pt">
              <ul className="list-disc">
                <li>
                  <p>{contentLine1}</p>
                </li>
                <li>
                  <p>{contentLine2}</p>
                </li>
                <li>
                  <p>{contentLine3}</p>
                </li>
              </ul>
            </div>
            <p className="error-pg-message-content error-pg-message-content-desc">
              {contentLine4}
              {contentLine5}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LowesAccountError;
